import React, {Fragment} from 'react';

const MarketPlace = () => {
  return (
    <Fragment>
      <iframe id="marketPlaceId" src={'https://airtable.com/embed/shrsIfw02AL3nZwqk?backgroundColor=teal'} width="100%" height="100%"/>
    </Fragment>
  )
}

export default MarketPlace;